import { hasModule } from 'lib/helpers/utility';

import { LETTER_TYPES, LOW_ASSURANCE_DISPLAY_AMOUNTS, TOPS_PAYMENT_OPTION_FIELDS } from './fields';

export * from './fields';
export { paymentMethods, DEFAULT_PAYMENT_SETUP, hydratePaymentSetup } from './defaultPaymentSetup';

export const PAYMENT_METHOD_MODULE_MAP = {
  cash: 'medipay.payment_suite.cash',
  check: 'medipay.payment_suite.check',
  card: 'medipay.payment_suite.credit_card',
  'credit-card': 'medipay.payment_suite.credit_card',
  'saved-cards': 'medipay.payment_suite.credit_card',
  ach: 'medipay.payment_suite.ach',
  'outside-financing': 'medipay.payment_suite.outside_financing',
  'recurring-charge': 'medipay.payment_suite.recurring_charges',
  'request-payment': 'medipay.payment_suite.recurring_charges'
};

export const TOPS_PAYMENT_OPTION_MODULE_MAP = {
  [TOPS_PAYMENT_OPTION_FIELDS.PAYMENT_PLAN]: 'medipay.payment_suite.recurring_charges'
};

export const isPaymentMethodModuleEnabled = (practiceModules, methodKey) => {
  if (!practiceModules) return true;

  const path = PAYMENT_METHOD_MODULE_MAP[methodKey];
  if (!path) return true;
  return !!hasModule(practiceModules, path);
};

export const sendToPatientOptions = [
  {
    title: 'Good faith estimate',
    caption: 'Includes Good Faith Estimate compliance language required by the No Surprises Act.',
    value: LETTER_TYPES.GOOD_FAITH_ESTIMATE,
    details: `The GFE Patient Option Letter is a proprietary, copyrighted artifact designed to evoke transparency and tap into the psychology of patient payment — framing payment or a payment arrangement before treatment as the expected, normal part of care. It's built to reduce post-service A/R, increase collection rates at the point of care, and give patients a clear, dignified path forward when they need accommodations.`
  },
  {
    title: 'Patient option letter',
    caption: 'Streamlined letter with payment options only — no GFE compliance disclaimers.',
    value: LETTER_TYPES.PATIENT_OPTION_LETTER,
    details: `The Patient Option Letter is a proprietary, copyrighted artifact designed to evoke transparency and tap into the psychology of patient payment — framing payment or a payment arrangement before treatment as the expected, normal part of care. It's built to reduce post-service A/R, increase collection rates at the point of care, and give patients a clear, dignified path forward when they need accommodations.`
  },
  {
    title: 'Tops - Myriad GFE/POL',
    caption:
      'GFE/POL with patient-selectable payment options (reservation savings, payment plan, half down) for the visit.',
    value: LETTER_TYPES.TOPS_GFE_POL,
    details: `Tops - Myriad GFE/POL includes everything on the Good Faith Estimate letter, plus the Tops payment options patients can select for the visit \u2014 reservation savings for paying in full now, a payment plan based on credit approval, or half down with the remainder on a later date. Choose which arrangements to offer and set their terms below.`
  }
];

export const lowAssuranceDisplayOptions = [
  {
    title: 'Estimated amount',
    caption: 'Show the estimated patient portion calculated from the unverified benefits.',
    value: LOW_ASSURANCE_DISPLAY_AMOUNTS.ESTIMATE
  },
  {
    title: 'Full treatment cost',
    caption:
      'Show the full charge for the visit, before any insurance is applied. Patients are still charged no more than the estimated amount.',
    value: LOW_ASSURANCE_DISPLAY_AMOUNTS.FULL_COST
  }
];

export const topsPaymentOptions = [
  {
    field: TOPS_PAYMENT_OPTION_FIELDS.RESERVATION_SAVINGS,
    title: 'Reservation savings',
    description:
      'Discount when the patient pays in full now (when they receive the GFE). Outside financing not eligible.',
    icon: 'discount-1-mono'
  },
  {
    field: TOPS_PAYMENT_OPTION_FIELDS.PAYMENT_PLAN,
    title: 'Payment Plan Option',
    description: 'Installments based on credit approval.',
    icon: 'file-invoice-mono'
  },
  {
    field: TOPS_PAYMENT_OPTION_FIELDS.HALF_DOWN,
    title: 'Half down, remaining later',
    description:
      'Split the estimated patient portion \u2014 a portion now, the remainder on a later date.',
    icon: 'chart-1-mono'
  }
];

export const paymentTypes = [
  { value: 'in-person', title: 'In-person', icon: 'users-mono' },
  { value: 'remote', title: 'Remote', icon: 'video-camera-mono' }
];

export const RECURRING_CHARGE_FREQUENCIES = [
  { value: 'weekly', label: 'Weekly' },
  { value: 'bi-weekly', label: 'Every 2 weeks' },
  { value: 'monthly', label: 'Monthly' }
];

export const RECURRING_CHARGE_DURATIONS = [
  { value: 3, label: '3 months' },
  { value: 6, label: '6 months' },
  { value: 9, label: '9 months' },
  { value: 12, label: '12 months' },
  { value: 18, label: '18 months' },
  { value: 24, label: '24 months' }
];
